import { render, staticRenderFns } from "./FilterPill.vue?vue&type=template&id=3f51ecc8&scoped=true&"
import script from "./FilterPill.vue?vue&type=script&lang=js&"
export * from "./FilterPill.vue?vue&type=script&lang=js&"
import style0 from "./FilterPill.vue?vue&type=style&index=0&id=3f51ecc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f51ecc8",
  null
  
)

export default component.exports